const SectionCard = ({ title, color = "blue", children, padding="" }) => {

  return (
    <div className="border rounded mb-3">
      <div className={`px-4 py-2 border-b rounded bg-btn ${padding}`}>
        <p className="font-bold text-white text-lg">{title}</p>
      </div>
      <div className="px-4 py-2">{children}</div>
    </div>
  );
};
export default SectionCard;
